import { useCallback, useState } from "react";

export const useUserPops = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const clearError = useCallback(() => {
    setError("");
  }, []);

  const reset = useCallback(() => {
    setLoading(false);
    setError("");
  }, []);

  return {
    loading,
    error,
    clearError,
    reset,
  };
};

export default useUserPops;
